import * as $http from 'axios'

export default {
    all: () => $http.get('v2/invite_histories'),
    create: payload => $http.post('v2/invite_histories', payload),
}
